export class Csv {
  static type = 'csv'

  type = Csv.type

  file?: string
}
